import { createSelector } from 'reselect';

import {
  getArmyListUnitOptions,
  getCurrentArmyListUnit,
  getUnit,
  showDetails,
  showPoints,
} from './exportSelector';

export const exportOption = createSelector(
  [getArmyListUnitOptions],
  (options): string => {
    // other than command, equip & rule and default options

    return options
      .map((item) => item.name)
      .filter((item) => item != '')
      .join(', ');
  },
);

export const exportArmyListUnit = createSelector(
  [getCurrentArmyListUnit, getUnit, exportOption, showPoints, showDetails],
  (armyListUnit, unit, option, showPoints, showDetails): string => {
    if (!armyListUnit || !unit) return '';

    let name = `${unit.name}`;
    if (showDetails) {
      const points =
        unit.points +
        unit.add_value_points * (armyListUnit.size - unit.min_size);
      name = `${name} (${points})`;
    }

    if (armyListUnit.size > 1) {
      name = `${armyListUnit.size}x ${name}`;
    }

    if (showPoints) {
      name = `${armyListUnit.points} - ${name}`;
    }

    if (option != '') {
      name = `${name}, ${option}`;
    }

    return name;
  },
);
